var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#3769FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18522 4.70769C6.51659 4.70769 6.7897 4.8532 6.82702 5.04065L6.83137 5.08461V8.85384C6.83137 9.06201 6.54208 9.23076 6.18522 9.23076C5.85385 9.23076 5.58074 9.08526 5.54341 8.8978L5.53906 8.85384V5.08461C5.53906 4.87644 5.82836 4.70769 6.18522 4.70769ZM6.18522 2.76923C6.54208 2.76923 6.83137 3.05852 6.83137 3.41538C6.83137 3.77224 6.54208 4.06153 6.18522 4.06153C5.82836 4.06153 5.53906 3.77224 5.53906 3.41538C5.53906 3.05852 5.82836 2.76923 6.18522 2.76923Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/info-blue.9626b645cd7821c54b474094a65a98aa.svg";
export { ForwardRef as ReactComponent };